import { ParsedUrlQuery } from 'querystring';

import { ProductsListFilters, ProductsListSortMode } from '@domains/products-catalog';

import { parseArray, parseBoolean, parseNonNegativeInt, parsePositiveInt } from '@utils/query';

import { minSearchQueryLength, sortModes } from './constants';

export const parseProductsListSortMode = (value: QueryParam): ProductsListSortMode | null =>
    typeof value === 'string' && sortModes.includes(value as ProductsListSortMode)
        ? (value as ProductsListSortMode)
        : null;

export const parseCatalogSearchQuery = (value: QueryParam): string | null =>
    typeof value === 'string' && value.length >= minSearchQueryLength ? value : null;

export const parseFilters = (query: ParsedUrlQuery): ProductsListFilters => {
    const isNovelty = parseBoolean(query.is_novelty);
    const isReadyToEat = parseBoolean(query.is_ready_to_eat);
    const isPromo = parseBoolean(query.is_promo);
    const minPrice = parseNonNegativeInt(query.min_price);
    const maxPrice = parsePositiveInt(query.max_price);
    const countries = parseArray(query.countries);
    const manufacturers = parseArray(query.manufacturers);

    const filters: ProductsListFilters = {};

    if (isNovelty !== null) filters.is_novelty = isNovelty;
    if (isReadyToEat !== null) filters.is_ready_to_eat = isReadyToEat;
    if (isPromo !== null) filters.is_promo = isPromo;
    if (minPrice !== null) filters.min_price = minPrice as FeipApi.Kopecks;
    if (maxPrice !== null) filters.max_price = maxPrice as FeipApi.Kopecks;
    if (countries !== null) filters.countries = countries;
    if (manufacturers !== null) filters.manufacturers = manufacturers;

    return filters;
};
